// config default
export const DEFAULT_CONFIG = {
  favouriteCategoryIds: []
}
